import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import { Button, Flex, FormControl, FormLabel, Input, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Text } from '@chakra-ui/react'
import { ROLES } from 'lib'
import { UiSelect } from 'components/common'
import { getUsersByRoles } from 'api'
import { useAppContext } from 'hooks/useAppContext'

export const ModalTaskType = {
  Add: 'Add',
  Edit: 'Edit'
}

export const ModalTask = ({ modalType, isOpen, onClose, task, handleAdd, handleEdit, isSubmitting }) => {
  const { createToast } = useAppContext()
  const [title, setTitle] = useState('')
  const [assignedUser, setAssignedUser] = useState(null)

  useEffect(() => {
    setTitle(task?.title ?? '')
    setAssignedUser({ id: task?.assignedUserId ?? 0, name: task?.assignedUserName ?? '' })
  }, [task])

  const onCancel = () => {
    onClose()
  }

  const handleChange = (e) => {
    setTitle(e.target.value)
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    if (assignedUser?.id) {
      if (modalType === ModalTaskType.Add) {
        handleAdd(task.sectionId, title, assignedUser?.id)
      } else {
        handleEdit(task.id, task.sectionId, title, assignedUser?.id, task.sort)
      }
    } else {
      createToast('error', 'Error', 'Select assigned to user.')
    }
  }

  return (
    <>
      <Modal size="xl" isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <form onSubmit={handleSubmit}>
            <ModalHeader>{modalType === ModalTaskType.Add ? 'Add' : 'Edit'} Task</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              <FormControl isRequired>
                <FormLabel>Title</FormLabel>
                <Input type="text" name="title" value={title} onChange={handleChange} />
              </FormControl>
              <FormControl mt={2} isRequired>
                <FormLabel>Assign to</FormLabel>
                <UiSelect
                  value={assignedUser}
                  onChange={v => setAssignedUser(v)}
                  loadData={(page, search) => getUsersByRoles(page, 20, search, 'name', 'asc', [ROLES.ProjectManager, ROLES.Admin, ROLES.SalesUserProjectManager])}
                  apiRespProp="rows"
                  getOptionValue={v => v.id}
                  getOptionLabel={v => v.name}
                  placeholder="Search Users"
                  noOptionsMessage={() => 'No Users Found'}
                  required={true}
                />
              </FormControl>
            </ModalBody>

            <ModalFooter>
              <Flex justifyContent="flex-end" columnGap={2}>
                {modalType === ModalTaskType.Add && (
                  <Button type="submit" size="sm" colorScheme="blue" isLoading={isSubmitting}>Add</Button>
                )}
                {modalType === ModalTaskType.Edit && (
                  <Button type="submit" size="sm" colorScheme="blue" isLoading={isSubmitting}>Save</Button>
                )}
                <Button size="sm" colorScheme="gray" onClick={onCancel}>Cancel</Button>
              </Flex>
            </ModalFooter>
          </form>
        </ModalContent>
      </Modal>
    </>
  )
}

ModalTask.propTypes = {
  modalType: PropTypes.oneOf(Object.values(ModalTaskType)).isRequired,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  task: function (props, propName, componentName) {
    if (props.modalType === ModalTaskType.Edit) {
      if (!props[propName]) {
        return new Error(
          `The prop \`${propName}\` is required when modalType is ${ModalTaskType.Edit} in ${componentName}.`
        )
      }
    }
  },
  handleAdd: PropTypes.func,
  handleEdit: PropTypes.func,
  isSubmitting: PropTypes.bool
}

export const ModalRemoveTask = ({ task, isSubmitting, handleRemove, isOpen, onClose }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Remove Task</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Text>Are you sure to remove the task - {task?.title}?</Text>
        </ModalBody>

        <ModalFooter>
          <Button colorScheme='red' mr={3} onClick={() => handleRemove(task?.id)} isLoading={isSubmitting}>
            Remove
          </Button>
          <Button variant='ghost' onClick={onClose}>Close</Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}

ModalRemoveTask.propTypes = {
  task: PropTypes.object,
  isSubmitting: PropTypes.bool,
  handleRemove: PropTypes.func,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func
}
